import { Injectable } from '@angular/core';
import * as wizeMobileApi from '@wize-mobile-api';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { InvestmentOrderMapper } from '~/modules/investmentOrder/investment-order.mapper';
import { InvestmentOrder } from '@qvs/core';
import { loadInvestmentOrders } from '~/modules/investmentOrder/slice/investment-order.actions';
import { environment } from '#environment';

@Injectable({
  providedIn: 'root'
})
export class InvestmentOrderService {
  constructor(
    private readonly store: Store,
    private readonly wizeService: wizeMobileApi.StockMarketOrderAPIService
  ) {}

  public loadInvestmentOrders = (maxResults: number): Observable<InvestmentOrder[]> =>
    this.wizeService.getOrders(maxResults).pipe(switchMap((wizeOrders) => of(InvestmentOrderMapper.fromWizeOrders(wizeOrders))));

  public loadInvestmentOrder = (orderId: number): Observable<InvestmentOrder> =>
    this.wizeService.getOrder(orderId).pipe(switchMap((wizeOrder) => of(InvestmentOrderMapper.fromWizeOrder(wizeOrder))));

  public init(): Promise<void> {
    if (environment.featureFlags.isInvestmentsEnabled) {
      this.store.dispatch(loadInvestmentOrders({ maxResults: 100 }));
    }
    return Promise.resolve();
  }
}
